import { FocusOrigin } from '@angular/cdk/a11y';

export class DomUtils {

  public static isEllipsisActive(element: HTMLElement): boolean {
    return element?.scrollWidth > element?.offsetWidth;
  }

  public static isContentScrollable(element: HTMLElement): boolean {
    return element?.scrollHeight > element?.clientHeight;
  }

  public static isFocusedFromKeyboardEvent(origin?: FocusOrigin) {
    return origin === 'keyboard';
  }
}
